export default "__VITE_ASSET__CXywB$2I__"